import { TAXES_PAYMENTS_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { TaxesPaymentsRowView } from './types';

export function buildTaxesPaymentsQueueItem(row: TaxesPaymentsRowView): ApprovalQueueItem {
  return {
    categoryId: TAXES_PAYMENTS_CATEGORY.id,
    categoryLabel: TAXES_PAYMENTS_CATEGORY.label,
    description: `${row.name} requires review.`,
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function getTaxesPaymentsSearchText(row: TaxesPaymentsRowView) {
  return [row.name, row.field, row.statusLabel].filter(Boolean).join(' ');
}
